export default "__VITE_ASSET__C61JG6AX__"